import React, { useEffect, useState } from 'react'
import PageTitle from '../../../baseComponents/PageTitle'
import { getVademecum } from '../../../services/vademecum'

import titleLogo from '../../../assets/images/title-icons/Stethoscope-Line.svg'
import { ReactComponent as Logo } from '../../../assets/images/title-icons/People-Line.svg'
import peopleLogo from '../../../assets/images/title-icons/People-Line.svg'
import Loader from '../../../baseComponents/Loader'
import arrow from '../../../assets/images/svg_icons/arrow.svg'

const Vademecum = props => {
  const { texts, lang } = props
  const [isFetching, setIsFetching] = useState(true)
    , [activeClass, setActiveClass] = useState('')
    , [data, setData] = useState({})

  useEffect(() => {
    let timeout = null
    getVademecum()
      .then(res => {
        setData(res)
        setIsFetching(false)
        timeout = setTimeout(() => {
          setActiveClass('active')
          // document.getElementById('healthcares').classList.add('active')
        }, 500)
      })
      .catch(err => console.log(err))
    return () => {
      clearTimeout(timeout)
    }
  }, [])


  if (isFetching) return <Loader />

  let info = data[lang]
  let title = info.title ? info.title : texts.title
    , label = info.titleRedLabel ? info.titleRedLabel : ''


  return <div id='vademecum' className={`${activeClass} transition`}>
    <PageTitle title={title} label={label} logo={titleLogo} />
    <div className='operations__container  animals-section'>
      <div className='operations__slider transition'>
        <div className='operations__slider-container'>
          <img src={info.doctorsBanner} alt='banner' />
        </div>
      </div>
      <div className={`abosolute ${activeClass} box-shadow transition`}>
        <div className='operations__main-content-header'>
          <img src={peopleLogo} className='title-logo transition' alt='search' />
          <h3>{info.doctorsTitle}</h3>
        </div>
        <div className='operations__text-content' dangerouslySetInnerHTML={{ __html: info.doctorsParagraphs }} />

        <div className='link-container'>
          <a className='link' href={info.doctorsLink.link} target='_blank' rel='noreferrer'>
            {info.doctorsLink.label}
            <img className='arrow-left' src={arrow} alt='flecha' />
          </a>
        </div>

        {
          Boolean(info.advertising) && Boolean(info.advertising.title) &&
          <p className='operations__text-content' >{info.advertising.title}</p>
        }
      </div>
    </div>
    <div className='page__background-logo transition'>
      <Logo />
    </div>
  </div>
}

export default Vademecum